import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  margin-top: 32px;
  background-color: ${colors.$ffffff};
  border-radius: 22px;

  @media (min-width: ${breakpoints.tablet}) {
    border-radius: 26px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    border-radius: 32px;
  }
`;

export const TopImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  background-color: transparent;

  @media (min-width: ${breakpoints.tablet}) {
    height: 200px;
  }
`;

export const ImageContainer = styled.div`
  z-index: 2;

  img {
    cursor: default;
    max-width: 212px;
    max-height: 75px;
    object-fit: contain;

    @media (min-width: ${breakpoints.tablet}) {
      max-width: 317.5px;
      max-height: 112px;
    }
  }
`;

export const InnerContainer = styled.div`
  text-align: left;
  padding: 32px 24px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 32px 40px;
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${colors.$262626};
`;

export const Title = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(30, 38)}
`;

export const Description = styled(Paragraph)`
  margin-top: 24px;
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)}
`;

export const CtaContainer = styled.div`
  margin-top: 24px;
`;

export const QRContainer = styled(Container)`
  padding: 34px 55px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QRCodeImg = styled.div`
  img {
    cursor: default;
    max-height: 151px;
    max-width: 151px;
  }
`;

export const HeadText = styled(Paragraph)`
  margin-top: 34px;
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)}
  text-transform: uppercase;
`;

export const QRTitle = styled(Paragraph)`
  margin-top: 8px;
  font-family: ${fonts.exbold};
  ${pxToCssFont(36, 45)}
  color: ${colors.$e60000};
`;

export const QRDescription = styled(HeadText)`
  text-align: center;
  margin-top: 8px;
  text-transform: none;
`;

export const DivImgContainer = styled.div<{ absolute: boolean }>`
  height: 100%;
  width: 100%;
  min-height: 100%;
  min-width: 100%;
  overflow: hidden;
  position: ${(props) => (props.absolute ? 'absolute' : 'relative')};
  top: ${(props) => (props.absolute ? 0 : '')};
  left: ${(props) => (props.absolute ? 0 : '')};
`;

